// Sales phone numbers from admin branding (falls back to the main contact phone).
export function getSalesPhones(branding) {
  const list = Array.isArray(branding?.sales_phones) ? branding.sales_phones : [];
  const phones = list.map(p => String(p || '').trim()).filter(Boolean);
  if (phones.length === 0 && branding?.contact_phone) phones.push(String(branding.contact_phone).trim());
  return [...new Set(phones)];
}

export function joinPhones(phones, word = 'or') {
  if (phones.length <= 1) return phones[0] || '';
  return `${phones.slice(0, -1).join(', ')} ${word} ${phones[phones.length - 1]}`;
}
